import { Utils } from '~/Utils'

export const useAntdBackendTable = (fetchData: (params: any) => void) => {
  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    const params: any = {}

    params.page = pagination.current
    params.pageSize = pagination.pageSize

    const filterQuery = Utils.buildAntdFilterQuery(filters)

    if (filterQuery) {
      params.filter = filterQuery
    }

    if (sorter?.field && sorter?.order) {
      params.sort = {
        field: sorter.field,
        order: sorter.order,
      }
    }

    fetchData(params)
  }

  return { handleTableChange }
}
